import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
export const SmallTagBase = (props) => {
    const { children, className, isFullRounded = false, isKanjiTopFixed = false, textClassName = '', textColor, } = props;
    return (_jsx("div", Object.assign({ className: clsx('h-[20px]', 'inline-flex flex-nowrap items-center justify-center', 'px-4', isFullRounded ? 'rounded-full' : 'rounded-sm', className) }, { children: _jsx(Text, Object.assign({ className: clsx('!leading-none relative', isKanjiTopFixed && 'top-[-0.5px]', textClassName), color: textColor, size: 'xs', tagName: 'span' }, { children: children })) })));
};
